import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=625bd704&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625bd704')) {
      api.createRecord('625bd704', component.options)
    } else {
      api.reload('625bd704', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=625bd704&", function () {
      api.rerender('625bd704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2faaTuQKO2l2D/JS/comp/IncreaseNumber.vue"
export default component.exports